if (!window.customElements.get("cart-sell-option")) {
    class CartSellOption extends HTMLElement {
        constructor() {
            super();
            this.raffleTicketInputs = this.querySelectorAll("input[name='raffle_ticket'], input[name='cart_raffle_ticket']");
            this.jumpTheQueueInputs = this.querySelectorAll("input[name='jump_the_queue'], input[name='cart_jump_the_queue']");
            this.pillLoader = this.querySelector("pill-loader");
            this.pageType = this.dataset.pageType;

            this.bindEvents();
        }

        bindEvents() {
            const _this = this;
            if (this.raffleTicketInputs.length) {
                this.raffleTicketInputs.forEach((raffleTicketInput) => raffleTicketInput.addEventListener("change", _this.handleInputChange.bind(this), true));
            }

            if (this.jumpTheQueueInputs.length) {
                this.jumpTheQueueInputs.forEach((jumpTheQueueInput) => jumpTheQueueInput.addEventListener("change", _this.handleInputChange.bind(this), true));
            }
        }

        handleInputChange = async (event) => {
            const { dataset: { id }, checked } = event.target;
            if (!id) return;
            if (this.pillLoader) this.pillLoader.setAttribute('aria-busy', true);

            const productObject = { id, quantity: 1 };

            if (checked) {
                await this.addItemToCart(productObject);
            } else {
                await this.removeItemToCart({ ...productObject, quantity: 0 });
            }
        }

        async removeItemToCart(items) {
            const _this = this;
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
            const formData = { ...items, sections: sectionsToBundle };
            fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) })
                .then(response => {
                    return response.json();
                })
                .then(async (cartResponse) => {
                    if (_this.pageType !== "cart") {
                        const sections = cartResponse.sections;
                        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                        _this.reloadCart({ ...cartContent, sections });
                    } else {
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    if (_this.pillLoader) _this.pillLoader.removeAttribute('aria-busy');
                });
        }

        async addItemToCart(items) {
            const _this = this;
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
            const formData = { 'items': [items], sections: sectionsToBundle };

            fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) })
                .then(response => {
                    return response.json();
                })
                .then(async (cartResponse) => {
                    if (_this.pageType !== "cart") {
                        const sections = cartResponse.sections;
                        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
                        _this.reloadCart({ ...cartContent, sections });
                    } else {
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    if (_this.pillLoader) _this.pillLoader.removeAttribute('aria-busy');
                });
        }

        async reloadCart(cartContent) {
            if (this.pillLoader) this.pillLoader.removeAttribute('aria-busy');
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "variant:add",
                    cart: cartContent
                }
            }));
        }
    }

    window.customElements.define("cart-sell-option", CartSellOption);
}